import { PapiMessage, PapiNcMessage } from '@wix/da-papi-types';
import { deviations, deviationsByType } from '../deviations';
import { users } from '../users';
import { collections } from '../collections';
import { galleries } from '../galleries';

import { makeNCNotification } from '../fakes/notification';
import { integer, pickone, pickset } from '../helpers';
import { coreBadges, badgesByName } from '../badges';
import { Chance } from 'chance';
import { groups } from '../groups';
import {
  extendAdoptable,
  makeNcComment,
  makeNcGroupVotingCorrespondenceNotificationSet,
  makeNcModerationReportData,
} from './utils';
import generated from './generated';

const chance = new Chance();

const byType = {
  new_watcher: makeNCNotification('nc.new_watcher', {
    messageData: {
      dataKey: 'new_watcher',
      newWatcher: {
        newestDeviations: pickset(
          deviations,
          integer({
            min: 1,
            max: 6,
          })
        ),
        watched: pickone(users),
      },
    },
  }),
  fave: makeNCNotification('nc.fave', {
    messageData: {
      dataKey: 'fave',
      fave: {
        deviation: pickone(deviations),
      },
    },
  }),
  collect: makeNCNotification('nc.collect', {
    messageData: {
      dataKey: 'collect',
      collect: {
        collection: pickone(collections),
        deviation: pickone(deviations),
      },
    },
  }),
  private_collect: makeNCNotification('nc.private_collect', {
    messageData: {
      dataKey: 'privateCollect',
      privateCollect: {
        deviation: pickone(deviations),
      },
    },
  }),
  badge_given: makeNCNotification('nc.badge_given', {
    messageData: {
      dataKey: 'badge_given',
      badgeGiven: {
        badge: {
          id: 12521153,
          typeId: 1,
          name: 'llama',
          title: 'Super Albino Llama',
          baseTitle: 'Llama',
          description: 'Llamas are awesome!',
          descriptionLong:
            'Your awesome submission got you this badge! and now you can proudly display it on your profile. Stay tuned for more great tutorials and badges!',
          linkText: 'Show me my badges',
          linkUrl: 'https://www.google.com',
          buttonText: 'More Info',
          buttonUrl: 'https://www.google.com',
          stackCount: 136,
          images: [
            {
              imageUrl:
                'https://st.deviantart.net/badges/llama_superalbino.gif',
              className: '',
            },
          ],
        },
      },
    },
  }),
  badge_levelled: makeNCNotification('nc.badge_levelled', {
    messageData: {
      dataKey: 'badge_levelled',
      badgeLevelled: {
        badge: {
          id: 12521153,
          typeId: 1,
          name: 'llama',
          title: 'Super Albino Llama',
          baseTitle: 'Llama',
          description: 'Llamas are awesome!',
          descriptionLong:
            'Your awesome submission got you this badge! and now you can proudly display it on your profile. Stay tuned for more great tutorials and badges!',
          linkText: 'Show me my badges',
          linkUrl: 'https://www.google.com',
          buttonText: 'More Info',
          buttonUrl: 'https://www.google.com',
          stackCount: 136,
          images: [
            {
              imageUrl:
                'https://st.deviantart.net/badges/llama_superalbino.gif',
              className: '',
            },
          ],
        },
      },
    },
  }),
  dd_to_author: makeNCNotification('nc.dd_to_author', {
    messageData: {
      dataKey: 'dd_to_author',
      ddToAuthor: {
        deviation: pickone(deviations),
        ts: new Date().toISOString(),
      },
    },
  }),
  award_badge_given_on_comment: makeNCNotification(
    'nc.award_badge_given_on_comment',
    {
      messageData: {
        dataKey: 'award_badge_given_on_comment',
        awardBadgeGivenOnComment: {
          comment: makeNcComment(),
          badge: pickone(coreBadges),
          profit: pickone([100, 200, 300]),
        },
      },
    }
  ),
  award_badge_given_on_comment_quartz: makeNCNotification(
    'nc.award_badge_given_on_comment',
    {
      messageData: {
        dataKey: 'award_badge_given_on_comment',
        awardBadgeGivenOnComment: {
          comment: makeNcComment(),
          badge: coreBadges[0],
          profit: 10,
        },
      },
    }
  ),
  award_badge_given_on_comment_emerald: makeNCNotification(
    'nc.award_badge_given_on_comment',
    {
      messageData: {
        dataKey: 'award_badge_given_on_comment',
        awardBadgeGivenOnComment: {
          comment: makeNcComment(),
          badge: coreBadges[1],
          profit: 100,
        },
      },
    }
  ),
  award_badge_given_on_comment_diamond: makeNCNotification(
    'nc.award_badge_given_on_comment',
    {
      messageData: {
        dataKey: 'award_badge_given_on_comment',
        awardBadgeGivenOnComment: {
          comment: makeNcComment(),
          badge: coreBadges[2],
          profit: 300,
        },
      },
    }
  ),
  award_badge_given_on_deviation_quartz: makeNCNotification(
    'nc.award_badge_given_on_deviation',
    {
      messageData: {
        dataKey: 'award_badge_given_on_deviation',
        awardBadgeGivenOnDeviation: {
          deviation: pickone(deviations),
          badge: coreBadges[0],
          profit: 10,
        },
      },
    }
  ),
  award_badge_given_on_deviation_emerald: makeNCNotification(
    'nc.award_badge_given_on_deviation',
    {
      messageData: {
        dataKey: 'award_badge_given_on_deviation',
        awardBadgeGivenOnDeviation: {
          deviation: pickone(deviations),
          badge: coreBadges[1],
          profit: 100,
        },
      },
    }
  ),
  award_badge_given_on_deviation_diamond: makeNCNotification(
    'nc.award_badge_given_on_deviation',
    {
      messageData: {
        dataKey: 'award_badge_given_on_deviation',
        awardBadgeGivenOnDeviation: {
          deviation: pickone(deviations),
          badge: coreBadges[2],
          profit: 300,
        },
      },
    }
  ),
  award_badge_given_on_deviation_boost: makeNCNotification(
    'nc.award_badge_given_on_deviation',
    {
      messageData: {
        dataKey: 'award_badge_given_on_deviation',
        awardBadgeGivenOnDeviation: {
          deviation: pickone(deviations),
          profit: 0,
          // todo: this isn't in the sample data, vm, or GA yet AFAIK
          // badge: badgesByName['boost'],
          badge: {
            ...badgesByName['TheHype'],
            typeId: 176,
            name: 'Boost',
            title: 'Boost',
            baseTitle: 'Boost',
            description: 'Congrats! Your deviation is now boosted',
            descriptionLong:
              'Your deviation will get enhanced exposure for 48 hours.',
            buttonText: 'Learn About Boost',
            buttonUrl:
              'https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments',
            giveLabel: 'Boost Deviation Exposure',
            giveExplanation: 'and boost this deviation in browse!',
            isSpectacular: true,
            isBooster: true,
          },
        },
      },
    }
  ),
  dd_to_suggester: makeNCNotification('nc.dd_to_suggester', {
    messageData: {
      dataKey: 'dd_to_suggester',
      ddToSuggester: {
        deviation: pickone(deviations),
        ts: new Date().toISOString(),
      },
    },
  }),
  comment_mentions_user: makeNCNotification('nc.comment_mentions_user', {
    messageData: {
      dataKey: 'comment_mentions_user',
      commentMentionsUser: {
        mentioner: makeNcComment(),
      },
    },
  }),
  comment_mentions_deviation: makeNCNotification(
    'nc.comment_mentions_deviation',
    {
      messageData: {
        dataKey: 'comment_mentions_deviation',
        commentMentionsDeviation: {
          mentioner: makeNcComment(),
          mentioned: pickone(deviations),
        },
      },
    }
  ),
  deviation_mentions_user: makeNCNotification('nc.deviation_mentions_user', {
    messageData: {
      dataKey: 'deviation_mentions_user',
      deviationMentionsUser: {
        mentioner: pickone(deviations),
      },
    },
  }),
  deviation_mentions_deviation: makeNCNotification(
    'nc.deviation_mentions_deviation',
    {
      messageData: {
        dataKey: 'deviation_mentions_deviation',
        deviationMentionsDeviation: {
          mentioner: pickone(deviations),
          mentioned: pickone(deviations),
        },
      },
    }
  ),
  art_theft_report: makeNCNotification('nc.art_theft_report', {
    messageData: {
      dataKey: 'art_theft_report',
      artTheftReport: {
        originalDeviation: chance.pickone(deviationsByType.image),
        infringingDeviation: chance.pickone(deviationsByType.image),
      },
    },
  }),
  points_transaction: makeNCNotification('nc.points_transaction', {
    messageData: {
      dataKey: 'points_transaction',
      pointsTransaction: {
        memoPreview: 'NC Fake Point Transaction',
        points: 200,
      },
    },
  }),
  comment: makeNCNotification('nc.comment', {
    messageData: {
      dataKey: 'comment',
      comment: {
        comment: makeNcComment(),
      },
    },
  }),
  pcp_sold: makeNCNotification('nc.pcp_sold', {
    messageData: {
      dataKey: 'pcp_sold',
      pcpSold: {
        order: {
          deviation: pickone(deviations),
          itemType: 'Premium Download',
          productName: 'NC Fake Premium Download',
          productUrl: 'https://www.deviantart.com/print/66676/',
          profit: 20,
        },
      },
    },
  }),
  radom_recommendation: makeNCNotification('nc.radom_recommendation', {
    messageData: {
      dataKey: 'radomRecommendation',
      radomRecommendation: {
        recommendedDeviation: pickone(deviations),
      },
    },
  }),
  group_created: makeNCNotification('nc.group_created', {
    messageData: {
      dataKey: 'group_created',
      groupCreated: {
        group: pickone(groups),
      },
    },
  }),
  group_joined: makeNCNotification('nc.group_joined', {
    messageData: {
      dataKey: 'group_joined',
      groupJoined: {
        member: pickone(users),
        role: {
          label: 'Contributors',
          name: 'contributor',
        },
      },
    },
  }),
  group_changed_role: makeNCNotification('nc.group_changed_role', {
    messageData: {
      dataKey: 'group_changed_role',
      groupChangedRole: {
        member: pickone(users),
        role: {
          label: 'Mudkips',
          name: 'mudkips',
        },
      },
    },
  }),
  group_left: makeNCNotification('nc.group_left', {
    messageData: {
      dataKey: 'group_left',
      groupLeft: {
        member: pickone(users),
      },
    },
  }),
  group_removed_deviation: makeNCNotification('nc.group_removed_deviation', {
    messageData: {
      dataKey: 'group_removed_deviation',
      groupRemovedDeviation: { deviation: pickone(deviationsByType.image) },
    },
  }),
  group_note: makeNCNotification('nc.group_note', {
    messageData: {
      dataKey: 'group_note',
      groupNote: {
        groupnote: {
          body: 'I am a group note',
          group: pickone(groups),
          noteId: 12234,
          sender: pickone(users),
          replies: 1,
          subject: 'Hi, this is a note to the group',
          ts: `${Date.now() / 1000}`,
        },
      },
    },
  }),
  moderation_report_request: {
    mature: makeNCNotification('nc.moderation_report_request', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('mature', 'pending'),
      },
    }),
    policy: makeNCNotification('nc.moderation_report_request', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('policy', 'pending'),
      },
    }),
    pornography: makeNCNotification('nc.moderation_report_request', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('pornography', 'pending'),
      },
    }),
    underage: makeNCNotification('nc.moderation_report_request', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('underage', 'pending'),
      },
    }),
    copyright: makeNCNotification('nc.moderation_report_request', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('copyright', 'pending'),
      },
    }),
    monetized_ai: makeNCNotification('nc.moderation_report_request', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('monetized_ai', 'pending'),
      },
    }),
  },
  moderation_report_need_release: {
    mrf: makeNCNotification('nc.moderation_report_need_release', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('policy', 'pending', {
          mrfRequest: true,
        }),
      },
    }),
    sprf: makeNCNotification('nc.moderation_report_need_release', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('policy', 'pending', {
          sprfRequest: true,
        }),
      },
    }),
  },
  moderation_report_need_info: {
    underage: makeNCNotification('nc.moderation_report_need_info', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('underage', 'pending'),
      },
    }),
    mature: makeNCNotification('nc.moderation_report_need_info', {
      messageData: {
        dataKey: 'correspondence',
        correspondence: makeNcModerationReportData('mature', 'pending'),
      },
    }),
  },
  commission_request_voting: makeNCNotification('nc.commission_request', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'voting',
        canVote: true,
        canWithdraw: false,
        result: 0,
        choices: [
          {
            label: 'yes',
            value: 1,
            votesCast: 1,
          },
          {
            label: 'no',
            value: 2,
            votesCast: 0,
          },
        ],
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  commission_request_decided_yes: makeNCNotification('nc.commission_request', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'decided',
        canVote: false,
        canWithdraw: false,
        result: 1,
        choices: [
          {
            label: 'yes',
            value: 1,
            votesCast: 1,
          },
          {
            label: 'no',
            value: 2,
            votesCast: 0,
          },
        ],
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  commission_request_decided_no: makeNCNotification('nc.commission_request', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'decided',
        canVote: false,
        canWithdraw: false,
        result: 2,
        choices: [
          {
            label: 'yes',
            value: 1,
            votesCast: 0,
          },
          {
            label: 'no',
            value: 2,
            votesCast: 1,
          },
        ],
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  commission_request_expired: makeNCNotification('nc.commission_request', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'expired',
        canVote: false,
        canWithdraw: false,
        result: 1,
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  commission_request_withdrawn: makeNCNotification('nc.commission_request', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'withdrawn',
        canVote: false,
        canWithdraw: false,
        result: 1,
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  originals_order_voting: makeNCNotification('nc.originals_order', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'voting',
        canVote: true,
        canWithdraw: false,
        result: 0,
        choices: [
          {
            label: 'yes',
            value: 1,
            votesCast: 1,
          },
          {
            label: 'no',
            value: 2,
            votesCast: 0,
          },
        ],
        bppModule: {
          dataKey: 'originals_order',
          originalsOrder: {
            deviation: pickone(deviationsByType.image),
            response: {
              responseId: 1,
              status: 'pending',
              user: pickone(users),
            },
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
          },
        },
      },
    },
  }),
  originals_order_decided_yes: makeNCNotification('nc.originals_order', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'decided',
        canVote: false,
        canWithdraw: false,
        result: 1,
        choices: [
          {
            label: 'yes',
            value: 1,
            votesCast: 1,
          },
          {
            label: 'no',
            value: 2,
            votesCast: 0,
          },
        ],
        bppModule: {
          dataKey: 'originals_order',
          originalsOrder: {
            deviation: pickone(deviationsByType.image),
            response: {
              responseId: 1,
              status: 'pending',
              user: pickone(users),
            },
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
          },
        },
      },
    },
  }),
  originals_order_decided_no: makeNCNotification('nc.originals_order', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'decided',
        canVote: false,
        canWithdraw: false,
        result: 2,
        choices: [
          {
            label: 'yes',
            value: 1,
            votesCast: 0,
          },
          {
            label: 'no',
            value: 2,
            votesCast: 1,
          },
        ],
        bppModule: {
          dataKey: 'originals_order',
          originalsOrder: {
            deviation: pickone(deviationsByType.image),
            response: {
              responseId: 1,
              status: 'pending',
              user: pickone(users),
            },
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
          },
        },
      },
    },
  }),
  originals_order_expired: makeNCNotification('nc.originals_order', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'expired',
        canVote: false,
        canWithdraw: false,
        result: 1,
        bppModule: {
          dataKey: 'originals_order',
          originalsOrder: {
            deviation: pickone(deviationsByType.image),
            response: {
              responseId: 1,
              status: 'pending',
              user: pickone(users),
            },
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
          },
        },
      },
    },
  }),
  originals_order_withdrawn: makeNCNotification('nc.originals_order', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'withdrawn',
        canVote: false,
        canWithdraw: false,
        result: 1,
        bppModule: {
          dataKey: 'originals_order',
          originalsOrder: {
            deviation: pickone(deviationsByType.image),
            response: {
              responseId: 1,
              status: 'pending',
              user: pickone(users),
            },
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
          },
        },
      },
    },
  }),
  adoptable_offer: makeNcGroupVotingCorrespondenceNotificationSet(
    'nc.adoptable_offer',
    {
      dataKey: 'adoptable_offer',
      adoptableOffer: {
        deviation: extendAdoptable(pickone(deviationsByType.image)),
        correspondenceUrl: 'http://example.org',
        points: chance.integer({ max: 1000, min: 10 }),
        dollars: chance.dollar({ max: 100, min: 1 }),
        bppInstigator: pickone(users),
        seller: pickone(users),
        additionalNote: chance.sentence(),
      },
    }
  ),
  adoptable_gift: makeNcGroupVotingCorrespondenceNotificationSet(
    'nc.adoptable_gift',
    {
      dataKey: 'adoptable_gift',
      adoptableGift: {
        deviation: extendAdoptable(pickone(deviationsByType.image)),
        points: chance.integer({ max: 1000, min: 10 }),
        dollars: chance.dollar({ max: 100, min: 1 }),
        bppInstigator: pickone(users),
        giftRecipient: pickone(users),
      },
    }
  ),
  adoptable_offer_receipt: makeNcGroupVotingCorrespondenceNotificationSet(
    'nc.adoptable_offer_receipt',
    {
      dataKey: 'adoptabobble_offer_receipt',
      adoptableOffer: {
        deviation: extendAdoptable(pickone(deviationsByType.image)),
        correspondenceUrl: 'http://example.org',
        points: chance.integer({ max: 1000, min: 10 }),
        dollars: chance.dollar({ max: 100, min: 1 }),
        bppInstigator: pickone(users),
        seller: pickone(users),
        additionalNote: chance.sentence(),
        disabledReason: null,
      },
    } as any
  ),
  adoptable_sold: makeNCNotification('nc.adoptable_sold', {
    messageData: {
      dataKey: 'adoptable_sale',
      adoptableSale: {
        order: {
          deviation: pickone(deviations),
          itemType: '',
          productName: chance.tv(),
          productUrl: chance.url(),
          profit: chance.d100(),
        },
      },
    },
  }),
  adoptable_bought: makeNCNotification('nc.adoptable_bought', {
    messageData: {
      dataKey: 'adoptable_sale',
      adoptableSale: {
        order: {
          deviation: pickone(deviations),
          itemType: '',
          productName: chance.tv(),
          productUrl: chance.url(),
          profit: chance.d100(),
        },
      },
    },
  }),
  adoptable_offer_alert: makeNCNotification('nc.adoptable_offer_alert', {
    messageData: {
      dataKey: 'adoptable_offer_alert',
      adoptableOfferAlert: {
        deviation: extendAdoptable(pickone(deviationsByType.image)),
        points: chance.integer({ max: 1000, min: 10 }),
        dollars: chance.dollar({ max: 100, min: 1 }),
        bppInstigator: pickone(users),
        seller: pickone(users),
        additionalNote: chance.sentence(),
        disabledReason: null,
      },
    } as any,
  }),
  adoptable_offer_ended: makeNCNotification('nc.adoptable_offer_ended', {
    messageData: {
      dataKey: 'adoptable',
      adoptable: {
        deviation: extendAdoptable(pickone(deviationsByType.image)),
      },
    } as any,
  }),
  model_tag_request: makeNcGroupVotingCorrespondenceNotificationSet(
    'nc.model_tag_request',
    {
      dataKey: 'modelRequest',
      modelRequest: {
        deviation: pickone(deviations),
        model: pickone(users),
      },
    }
  ),
  model_tag_request_receipt: makeNcGroupVotingCorrespondenceNotificationSet(
    'nc.model_tag_request_receipt',
    {
      dataKey: 'modelRequest',
      modelRequest: {
        deviation: pickone(deviations),
        model: pickone(users),
      },
    }
  ),
  deviation_submission_permission_request:
    makeNcGroupVotingCorrespondenceNotificationSet(
      'nc.deviation_submission_permission_request',
      {
        dataKey: 'groupDeviation',
        groupDeviation: {
          deviation: pickone(deviations),
          group: pickone(groups),
          folder: {
            name: 'Featured',
          },
        },
      }
    ),
  deviation_submission_permission_group_receipt:
    makeNcGroupVotingCorrespondenceNotificationSet(
      'nc.deviation_submission_permission_group_receipt',
      {
        dataKey: 'groupDeviation',
        groupDeviation: {
          deviation: pickone(deviations),
          group: pickone(groups),
          folder: {
            name: 'Featured',
          },
        },
      }
    ),
  blog_submission_group_notification:
    makeNcGroupVotingCorrespondenceNotificationSet(
      'nc.blog_submission_group_notification',
      {
        dataKey: 'groupBlog',
        groupBlog: {
          deviation: pickone(deviations),
          group: pickone(groups),
        },
      }
    ),
  blog_submission_author_receipt:
    makeNcGroupVotingCorrespondenceNotificationSet(
      'nc.blog_submission_author_receipt',
      {
        dataKey: 'groupBlog',
        groupBlog: {
          deviation: pickone(deviations),
          group: pickone(groups),
        },
      }
    ),
  gallery_bought: makeNCNotification('nc.gallery_bought', {
    messageData: {
      dataKey: 'premium_gallery',
      premiumGallery: {
        gallery: pickone(galleries),
      },
    },
  }),
  gallery_sold: makeNCNotification('nc.gallery_sold', {
    messageData: {
      dataKey: 'premium_gallery',
      premiumGallery: {
        gallery: pickone(galleries),
      },
    },
  }),
  ms_cancelled: makeNCNotification('nc.ms.cancelled', {
    messageData: {
      dataKey: 'member_subscription',
      memberSubscription: {
        tierDeviation: pickone(deviationsByType.tiers),
      },
    },
  }),
  ms_billing_fail: makeNCNotification('nc.ms.billing_fail', {
    messageData: {
      dataKey: 'member_subscription',
      memberSubscription: {
        tierDeviation: pickone(deviationsByType.tiers),
      },
    },
  }),
  ms_created_to_subscriber: makeNCNotification('nc.ms.created_to_subscriber', {
    messageData: {
      dataKey: 'member_subscription',
      memberSubscription: {
        tierDeviation: pickone(deviationsByType.tiers),
      },
    },
  }),
  ms_promotion_dyw: makeNCNotification('nc.ms.promotion_dyw', {
    messageData: {
      dataKey: 'member_subscription',
      memberSubscription: {
        tierDeviation: pickone(deviationsByType.tiers),
      },
    },
  }),
  ms_unsubscribed: makeNCNotification('nc.ms.unsubscribed', {
    messageData: {
      dataKey: 'member_subscription',
      memberSubscription: {
        tierDeviation: pickone(deviationsByType.tiers),
      },
    },
  }),
  ms_subscribed_to_owner: makeNCNotification('nc.ms.subscribed_to_owner', {
    messageData: {
      dataKey: 'member_subscription',
      memberSubscription: {
        tierDeviation: pickone(deviationsByType.tiers),
      },
    },
  }),
  ms_unsubscribed_to_owner: makeNCNotification('nc.ms.unsubscribed_to_owner', {
    messageData: {
      dataKey: 'member_subscription',
      memberSubscription: {
        tierDeviation: pickone(deviationsByType.tiers),
        reasonId: integer({ min: 0, max: 5 }),
      } as any,
    },
  }),
  commission_receipt_voting: makeNCNotification('nc.commission_receipt', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'voting',
        canVote: true,
        canWithdraw: true,
        result: 1,
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  commission_receipt_decided_yes: makeNCNotification('nc.commission_receipt', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'decided',
        canVote: false,
        canWithdraw: false,
        result: 1,
        choices: [
          {
            label: 'yes',
            value: 1,
            votesCast: 1,
          },
          {
            label: 'no',
            value: 2,
            votesCast: 0,
          },
        ],
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  commission_receipt_decided_no: makeNCNotification('nc.commission_receipt', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'decided',
        canVote: false,
        canWithdraw: false,
        result: 2,
        choices: [
          {
            label: 'yes',
            value: 1,
            votesCast: 0,
          },
          {
            label: 'no',
            value: 2,
            votesCast: 1,
          },
        ],
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  commission_receipt_expired: makeNCNotification('nc.commission_receipt', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'expired',
        canVote: false,
        canWithdraw: false,
        result: 1,
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  commission_receipt_withdrawn: makeNCNotification('nc.commission_receipt', {
    messageData: {
      dataKey: 'correspondence',
      correspondence: {
        status: 'withdrawn',
        canVote: false,
        canWithdraw: false,
        result: 1,
        bppModule: {
          dataKey: 'commission_request',
          commissionRequest: {
            commission: pickone(deviationsByType.commissions),
            correspondenceUrl: 'http://example.org',
            points: chance.integer({ max: 1000, min: 10 }),
            dollars: chance.dollar({ max: 100, min: 1 }),
            bppInstigator: pickone(users),
            seller: pickone(users),
            additionalNote: chance.sentence(),
          },
        },
      },
    },
  }),
  replied: makeNCNotification('nc.replied', {
    messageData: {
      dataKey: 'replied',
      replied: {
        comment: makeNcComment(),
        parentComment: makeNcComment(),
      },
    },
  }),
  comment_liked: makeNCNotification('nc.comment_liked', {
    messageData: {
      dataKey: 'comment',
      comment: {
        comment: makeNcComment(),
      },
    },
  }),
  group_invitation: makeNcGroupVotingCorrespondenceNotificationSet(
    'nc.group_invitation',
    {
      dataKey: 'group_membership',
      groupMembership: {
        role: 'test-role',
        group: pickone(groups),
        potentialMember: pickone(users),
        bppInstigator: pickone(users),
        additionalNote: 'Additional note',
      },
    }
  ),
  group_invitation_receipt: makeNcGroupVotingCorrespondenceNotificationSet(
    'nc.group_invitation_receipt',
    {
      dataKey: 'group_membership',
      groupMembership: {
        role: 'test-role',
        group: pickone(groups),
        potentialMember: pickone(users),
        bppInstigator: pickone(users),
        additionalNote: 'Additional note',
      },
    }
  ),
  group_join_request: makeNcGroupVotingCorrespondenceNotificationSet(
    'nc.group_join_request',
    {
      dataKey: 'group_membership',
      groupMembership: {
        role: 'test-role',
        group: pickone(groups),
        potentialMember: pickone(users),
        bppInstigator: pickone(users),
        additionalNote: 'Additional note',
      },
    }
  ),
  group_join_request_receipt: makeNcGroupVotingCorrespondenceNotificationSet(
    'nc.group_join_request_receipt',
    {
      dataKey: 'group_membership',
      groupMembership: {
        role: 'test-role',
        group: pickone(groups),
        potentialMember: pickone(users),
        bppInstigator: pickone(users),
        additionalNote: 'Additional note',
      },
    }
  ),
  core_gifted: makeNCNotification('nc.core_gifted', {
    messageData: {
      dataKey: 'core_gifted',
      coreGifted: {
        length: '1m',
        giftNote: chance.sentence(),
      },
    },
  }),
  core_gifted_anon: makeNCNotification('nc.core_gifted', {
    messageData: {
      dataKey: 'core_gifted',
      coreGifted: {
        length: '1m',
        giftNote: chance.sentence(),
        isAnonymous: true,
      },
    },
  }),
  deviation_submission_offer_group_notification_voting: makeNCNotification(
    'nc.deviation_submission_offer_group_notification',
    {
      messageData: {
        dataKey: 'correspondence',
        correspondence: {
          status: 'voting',
          canVote: true,
          canWithdraw: false,
          result: 0,
          showCounts: true,
          choices: [
            { value: 1, label: 'yes', votesCast: 0 },
            { value: 2, label: 'no', votesCast: 99 },
          ],
          numVotesNeeded: 99,
          bppModule: {
            dataKey: 'groupDeviation',
            groupDeviation: {
              deviation: pickone(deviationsByType.image),
              group: pickone(groups),
              folder: { name: 'Some Folder' },
              bppInstigator: pickone(users),
            },
          },
        },
      },
    }
  ),
  deviation_submission_offer_group_notification_decided_yes: makeNCNotification(
    'nc.deviation_submission_offer_group_notification',
    {
      messageData: {
        dataKey: 'correspondence',
        correspondence: {
          status: 'decided',
          canVote: false,
          canWithdraw: false,
          result: 1,
          showCounts: true,
          choices: [
            { value: 1, label: 'yes', votesCast: 0 },
            { value: 2, label: 'no', votesCast: 99 },
          ],
          numVotesNeeded: 99,
          bppModule: {
            dataKey: 'groupDeviation',
            groupDeviation: {
              deviation: pickone(deviationsByType.image),
              group: pickone(groups),
              folder: { name: 'Some Folder' },
              bppInstigator: pickone(users),
            },
          },
        },
      },
    }
  ),
  deviation_submission_offer_group_notification_decided_no: makeNCNotification(
    'nc.deviation_submission_offer_group_notification',
    {
      messageData: {
        dataKey: 'correspondence',
        correspondence: {
          status: 'decided',
          canVote: false,
          canWithdraw: false,
          result: 2,
          showCounts: true,
          choices: [
            { value: 1, label: 'yes', votesCast: 0 },
            { value: 2, label: 'no', votesCast: 99 },
          ],
          numVotesNeeded: 99,
          bppModule: {
            dataKey: 'groupDeviation',
            groupDeviation: {
              deviation: pickone(deviationsByType.image),
              group: pickone(groups),
              folder: { name: 'Some Folder' },
              bppInstigator: pickone(users),
            },
          },
        },
      },
    }
  ),
  deviation_submission_offer_artist_receipt_voting: makeNCNotification(
    'nc.deviation_submission_offer_artist_receipt',
    {
      messageData: {
        dataKey: 'correspondence',
        correspondence: {
          status: 'voting',
          canVote: true,
          canWithdraw: false,
          result: 0,
          showCounts: true,
          choices: [
            { value: 1, label: 'yes', votesCast: 0 },
            { value: 2, label: 'no', votesCast: 99 },
          ],
          numVotesNeeded: 99,
          bppModule: {
            dataKey: 'groupDeviation',
            groupDeviation: {
              deviation: pickone(deviationsByType.image),
              group: pickone(groups),
              folder: { name: 'Some Folder' },
              bppInstigator: pickone(users),
            },
          },
        },
      },
    }
  ),
  deviation_submission_offer_artist_receipt_decided_yes: makeNCNotification(
    'nc.deviation_submission_offer_artist_receipt',
    {
      messageData: {
        dataKey: 'correspondence',
        correspondence: {
          status: 'decided',
          canVote: false,
          canWithdraw: false,
          result: 1,
          showCounts: true,
          choices: [
            { value: 1, label: 'yes', votesCast: 0 },
            { value: 2, label: 'no', votesCast: 99 },
          ],
          numVotesNeeded: 99,
          bppModule: {
            dataKey: 'groupDeviation',
            groupDeviation: {
              deviation: pickone(deviationsByType.image),
              group: pickone(groups),
              folder: { name: 'Some Folder' },
              bppInstigator: pickone(users),
            },
          },
        },
      },
    }
  ),
  deviation_submission_offer_artist_receipt_decided_no: makeNCNotification(
    'nc.deviation_submission_offer_artist_receipt',
    {
      messageData: {
        dataKey: 'correspondence',
        correspondence: {
          status: 'decided',
          canVote: false,
          canWithdraw: false,
          result: 2,
          showCounts: true,
          choices: [
            { value: 1, label: 'yes', votesCast: 0 },
            { value: 2, label: 'no', votesCast: 99 },
          ],
          numVotesNeeded: 99,
          bppModule: {
            dataKey: 'groupDeviation',
            groupDeviation: {
              deviation: pickone(deviationsByType.image),
              group: pickone(groups),
              folder: { name: 'Some Folder' },
              bppInstigator: pickone(users),
            },
          },
        },
      },
    }
  ),
  deviation_submission_offer_artist_receipt_expired: makeNCNotification(
    'nc.deviation_submission_offer_artist_receipt',
    {
      messageData: {
        dataKey: 'correspondence',
        correspondence: {
          status: 'expired',
          canVote: false,
          canWithdraw: false,
          result: 2,
          showCounts: true,
          choices: [
            { value: 1, label: 'yes', votesCast: 0 },
            { value: 2, label: 'no', votesCast: 99 },
          ],
          numVotesNeeded: 99,
          bppModule: {
            dataKey: 'groupDeviation',
            groupDeviation: {
              deviation: pickone(deviationsByType.image),
              group: pickone(groups),
              folder: { name: 'Some Folder' },
              bppInstigator: pickone(users),
            },
          },
        },
      },
    }
  ),
  deviation_submission_offer_artist_receipt_withdrawn: makeNCNotification(
    'nc.deviation_submission_offer_artist_receipt',
    {
      messageData: {
        dataKey: 'correspondence',
        correspondence: {
          status: 'withdrawn',
          canVote: false,
          canWithdraw: false,
          result: 2,
          showCounts: true,
          choices: [
            { value: 1, label: 'yes', votesCast: 0 },
            { value: 2, label: 'no', votesCast: 99 },
          ],
          numVotesNeeded: 99,
          bppModule: {
            dataKey: 'groupDeviation',
            groupDeviation: {
              deviation: pickone(deviationsByType.image),
              group: pickone(groups),
              folder: { name: 'Some Folder' },
              bppInstigator: pickone(users),
            },
          },
        },
      },
    }
  ),
  asam_recommendation: makeNCNotification('nc.asam_recommendation', {
    messageData: {
      dataKey: 'asamRecommendation',
      asamRecommendation: {
        recommendedDeviation: pickone(deviations),
        shopUrl: 'https://www.deviantart.lan/superbearpower/shop',
      },
    },
  }),
  achievement_top_supporter: makeNCNotification(
    'nc.achievement_top_supporter',
    {
      messageData: {
        dataKey: 'achievement_top_supporter',
        achievementTopSupporter: {
          shopUrl: 'https://www.deviantart.lan/superbearpower/shop',
        },
      },
    },
    undefined,
    'class.achievement'
  ),
};

const ncNotifications: PapiNcMessage[] = [];

const flattenMessages = object => {
  if (object.messageId) {
    ncNotifications.push(object);
  } else if (object) {
    Object.values(object).forEach(flattenMessages);
  }
};

flattenMessages(byType);

// Append backend generated messages to test different cases
ncNotifications.push(...generated);

const promos: PapiMessage[] = [
  {
    messageId: 'id:promotions:22:853781895',
    type: 'promotions',
    orphaned: false,
    ts: '2019-09-19T05:29:40-0700',
    isNew: false,
    elnino: {
      itemId: 2222222222,
      content: {
        headline: 'kkkllk',
        body: 'asdsdsadad 1231213 __0__',
        button: {
          text: '213231',
          url: 'https://www.deviantart.com/',
        },
        secondaryButton: {
          text: 'adssad',
          url: 'https://www.deviantart.com/',
        },
      },
      design: {
        image: 'https://st.deviantart.net/minish/widgets/eager.gif',
        logo: 'https://st.deviantart.net/minish/widgets/eager.gif',
        backgroundImage: {
          url: 'https://st.deviantart.net/minish/widgets/eager.gif',
        },
        colors: {
          background: {
            first: '#fff',
            second: '#000',
          },
          headline: '#fff',
          body: '#fff',
        },
      },
      designMobile: {
        image: 'https://st.deviantart.net/minish/widgets/eager.gif',
        logo: 'https://st.deviantart.net/minish/widgets/eager.gif',
        backgroundImage: {
          url: 'https://st.deviantart.net/minish/widgets/eager.gif',
        },
        colors: {
          background: {
            first: '#fff',
            second: '#bbb',
          },
          headline: '#ddd',
          body: '#dddddd',
        },
      },
    },
  },
];

export { ncNotifications, byType, promos };
